<template>
	<div>
		<div class="col-md-12 mt-3 pl-3 none_gauge">
				
				<iframe src="http://new.wanfangdata.com.cn/index.html" ref="iframe" frameborder="0" class="w-100 h-100"></iframe>
				
			
		</div>
	</div>
</template>
<script>
	export default({
		name: 'paper',
		data: function() {
			return {
				
			}

		},
		created: function() {
			
		},
		mounted() {
			this.load();
		},

	})
</script>